export * from './keyStorage';
export * from './storageObserver';
export * from './webStorage';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/~/ngx-webstorage/dist/helpers/index.js
// module id = ../../../../ngx-webstorage/dist/helpers/index.js
// module chunks = 3